// extracted by mini-css-extract-plugin
export default {"navigation":"bisc5Mx9kRjpj8GEWDAl","placeHolderShimmer":"Kgf0psOqbzbsj1lcj4Pm"};